import styled from 'styled-components';

const PracticeAreaCourtDiv = styled.div`
  display: ${props => (props.$show ? 'block' : 'none')};
`;

PracticeAreaCourtDiv.displayName = 'PracticeAreaCourtDiv';

export default PracticeAreaCourtDiv;
